import React from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import Refund from './transactionRefund'
import Update from './transactionUpdate'
import InAppPayment from './transactionPayment'

class TransactionForm extends React.Component {
  constructor(props) {
    super(props)
    console.log('!!! PROPS in TransactionForm',this.props)
  }

  render() {
    const { selectedItem } = this.props
    const rawItem = selectedItem || {}
    const paymentGateway = rawItem.payment_gateway || {}
    const normalizedItem = {
      ...rawItem,
      program: rawItem.program || {},
      parent: rawItem.parent || {},
      athlete: rawItem.athlete || {},
      user: rawItem.user || {},
      plan: rawItem.plan || {},
      plans: rawItem.plans || {},
      merch: rawItem.merch || {},
      price_breakdown: rawItem.price_breakdown || {},
      payment_gateway: {
        ...paymentGateway,
        status: paymentGateway.status !== undefined
          ? paymentGateway.status
          : (rawItem.programs ? [] : {}),
        history: paymentGateway.history || [],
      },
    }
    const isEF2 = Object.prototype.hasOwnProperty.call(rawItem, 'programs')
    if (isEF2) {
      normalizedItem.programs = Array.isArray(rawItem.programs) ? rawItem.programs : []
    } else {
      delete normalizedItem.programs
    }
    const transactionProps = { ...this.props, selectedItem: normalizedItem }
    const isEF3 = !isEF2
    const program = normalizedItem.program
    const parent = normalizedItem.parent
    const user = normalizedItem.user
    const title = isEF3
      ? `${program.group_name || 'Transaction'}${normalizedItem.team_name ? ` [${normalizedItem.team_name}]` : ''}`
      : 'Multi-program transaction'
    const subtitle = isEF3
      ? `${parent.first_name || ''} ${parent.last_name || ''}`.trim()
      : `${user.first_name || ''} ${user.last_name || ''}`.trim()
    const status =
      isEF3 && normalizedItem.payment_gateway.status
        ? normalizedItem.payment_gateway.status.status || 'unknown'
        : !isEF3 && Array.isArray(normalizedItem.payment_gateway.status) && normalizedItem.payment_gateway.status.length
          ? normalizedItem.payment_gateway.status[normalizedItem.payment_gateway.status.length - 1].status || 'unknown'
          : 'unknown'

    return(
      <div className="transaction-modal-panel">
        <div className="transaction-modal-header">
          <div>
            <div className="transaction-modal-kicker">Transaction Record</div>
            <h3 className="transaction-modal-title">{title}</h3>
            <div className="transaction-modal-subtitle">{subtitle}</div>
          </div>
          <div className="transaction-modal-summary">
            <div className="transaction-modal-summary-label">Status</div>
            <div className="transaction-modal-summary-value">{status}</div>
          </div>
        </div>

        <Tabs defaultActiveKey={1} id="transaction-modal-tabs" className="transaction-modal-tabs">
        <Tab eventKey={1} title="Details" bsClass="">
            <Update tx={transactionProps} />
        </Tab>
        <Tab eventKey={2} title="Refund" bsClass="white-text">
          <Refund tx={transactionProps} loadPage={this.props.loadPage} payment_credentials={this.props.payment_credentials}/>
        </Tab>
        <Tab eventKey={3} title="Payment" bsClass="white-text">
          <InAppPayment tx={transactionProps} />
        </Tab>
      </Tabs>
      </div>
    )
  }
}

export default TransactionForm
